import { Fragment } from "react";
import { Button } from "core/components/form-controls";
import CDialog from "core/components/CDialog";
import { _t } from "core/language";
import type { TIngredient } from "./../../store/types";
import { useRequestIngredient } from './../../hooks/myIngredient'

type TIngredientRequest = {
  name: string;
  onRequestSuccess?: (ingredient: TIngredient) => void;
}

const IngredientRequest = ({
  name = '',
  onRequestSuccess,
}: TIngredientRequest) => {
  const {
    handleSubmit,
    loading,
    errorMessage,
    openModalError,
    setOpenModalError,
  } = useRequestIngredient(onRequestSuccess)

  return (
    <Fragment>
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2">
        <div className="w-full text-center">
          <label className="block mb-5">{_t('ingredient.nodata')}</label>
          <div className="flex justify-center">
            <Button
              label={_t('ingredient.request')}
              onClickBtn={() => handleSubmit?.(name)}
              loading={loading}
              classBtn="px-4"
            />
          </div>
        </div>
      </div>

      <CDialog
        open={openModalError}
        closeModal={() => setOpenModalError(false)}
        classNamechildren="px-[8px]"
        hideCancel
        submitText={_t("common.ok")}
      >
        <div className="w-full text-center">
          <p
            className="text-sm tracking-tighter"
            dangerouslySetInnerHTML={{__html: _t(`ingredient.msg.${errorMessage}`)}}
          />
        </div>
      </CDialog>
    </Fragment>
  )
}

export default IngredientRequest
